import Extractor from './extractor.js';

class Article extends Extractor{

  extract(item){
    const result = super.extract(item);
    const data = item.pagemap;

    result['img'] = this.getData(
      [
        {instance: data, object:'metatags', property: 'og:image'},        
        {instance: data, object:'imageobject', property: 'url'},
        {instance: data, object:'cse_image', property: 'src'},        
      ], null);

    result['author'] = this.getData(
      [
        {instance: data, object:'newsarticle', property: 'author'},
        {instance: data, object:'article', property: 'author'},
        {instance: data, object:'person', property: 'name'},
        {instance: data, object:'metatags', property: 'author'},
      ], null);

    result['publisher'] = this.getData(
      [
        {instance: data, object:'metatags', property: 'article:publisher'},
      ], null);

    result['section'] = this.getData(
      [
        {instance: data, object:'metatags', property: 'section'},
        {instance: data, object:'metatags', property: 'article:section'},
        {instance: data, object:'metatags', property: 'parsely:section'},
      ], null);

    result['title'] = this.getData(
      [
        {instance: data, object:'newsarticle', property: 'headline'},
        {instance: data, object:'metatags', property: 'og:title'},
        {instance: data, object:'metatags', property: 'dc.title'},
      ], item.title);

    result['intro'] = this.getData(
      [
        {instance: data, object:'newsarticle', property: 'description'},
        {instance: data, object:'metatags', property: 'og:description'},
      ], null);

    result['body'] = this.getData(
      [
        {instance: data, object:'article', property: 'articlebody'},
        {instance: data, object:'newsarticle', property: 'articlebody'},
        {instance: data, object:'metatags', property: 'dc.description'},
      ], item.snippet);

    result['keywords'] = this.getData(
      [
        {instance: data, object:'newsarticle', property: 'keywords'},
        {instance: data, object:'article', property: 'keywords'},
        {instance: data, object:'metatags', property: 'keywords'},
        {instance: data, object:'metatags', property: 'news_keywords'},
      ], null);

    result['datepublished'] = this.getData(
      [
        {instance: data, object:'newsarticle', property: 'datemodified'},
        {instance: data, object:'newsarticle', property: 'datepublished'},
        {instance: data, object:'article', property: 'datepublished'},
        {instance: data, object:'metatags', property: 'article:published_time'},
        {instance: data, object:'metatags', property: 'article:modified_time'},
        {instance: data, object:'metatags', property: 'displaydate'},       
      ], '');

    return result;
  }
}

export default (Article);


// WEBPACK FOOTER //
// ./src/search/extractor/article.js